<app-nav-item (click)="logOut()" iconUrl="assets/img/logout.png">
    {{ 'logout' | translate}}
    
</app-nav-item>